/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleRpcStatus } from './GoogleRpcStatus';
import {
  GoogleRpcStatusFromJSON,
  GoogleRpcStatusFromJSONTyped,
  GoogleRpcStatusToJSON,
  GoogleRpcStatusToJSONTyped,
} from './GoogleRpcStatus';
import type { V2beta1PipelineVersionReference } from './V2beta1PipelineVersionReference';
import {
  V2beta1PipelineVersionReferenceFromJSON,
  V2beta1PipelineVersionReferenceFromJSONTyped,
  V2beta1PipelineVersionReferenceToJSON,
  V2beta1PipelineVersionReferenceToJSONTyped,
} from './V2beta1PipelineVersionReference';
import type { V2beta1RunStorageState } from './V2beta1RunStorageState';
import {
  V2beta1RunStorageStateFromJSON,
  V2beta1RunStorageStateFromJSONTyped,
  V2beta1RunStorageStateToJSON,
  V2beta1RunStorageStateToJSONTyped,
} from './V2beta1RunStorageState';
import type { V2beta1RuntimeConfig } from './V2beta1RuntimeConfig';
import {
  V2beta1RuntimeConfigFromJSON,
  V2beta1RuntimeConfigFromJSONTyped,
  V2beta1RuntimeConfigToJSON,
  V2beta1RuntimeConfigToJSONTyped,
} from './V2beta1RuntimeConfig';
import type { V2beta1RuntimeStatus } from './V2beta1RuntimeStatus';
import {
  V2beta1RuntimeStatusFromJSON,
  V2beta1RuntimeStatusFromJSONTyped,
  V2beta1RuntimeStatusToJSON,
  V2beta1RuntimeStatusToJSONTyped,
} from './V2beta1RuntimeStatus';
import type { V2beta1PluginOutput } from './V2beta1PluginOutput';
import {
  V2beta1PluginOutputFromJSON,
  V2beta1PluginOutputFromJSONTyped,
  V2beta1PluginOutputToJSON,
  V2beta1PluginOutputToJSONTyped,
} from './V2beta1PluginOutput';
import type { V2beta1RuntimeState } from './V2beta1RuntimeState';
import {
  V2beta1RuntimeStateFromJSON,
  V2beta1RuntimeStateFromJSONTyped,
  V2beta1RuntimeStateToJSON,
  V2beta1RuntimeStateToJSONTyped,
} from './V2beta1RuntimeState';
import type { V2beta1RunDetails } from './V2beta1RunDetails';
import {
  V2beta1RunDetailsFromJSON,
  V2beta1RunDetailsFromJSONTyped,
  V2beta1RunDetailsToJSON,
  V2beta1RunDetailsToJSONTyped,
} from './V2beta1RunDetails';

/**
 *
 * @export
 * @interface V2beta1Run
 */
export interface V2beta1Run {
  /**
   * Input. ID of the parent experiment.
   * The default experiment ID will be used if this is not specified.
   * @type {string}
   * @memberof V2beta1Run
   */
  experiment_id?: string;
  /**
   * Output. Unique run ID. Generated by API server.
   * @type {string}
   * @memberof V2beta1Run
   */
  run_id?: string;
  /**
   * Required input. Name provided by user,
   * or auto generated if run is created by a recurring run.
   * @type {string}
   * @memberof V2beta1Run
   */
  display_name?: string;
  /**
   *
   * @type {V2beta1RunStorageState}
   * @memberof V2beta1Run
   */
  storage_state?: V2beta1RunStorageState;
  /**
   * Optional input. Short description of the run.
   * @type {string}
   * @memberof V2beta1Run
   */
  description?: string;
  /**
   * This field is Deprecated. The pipeline version id is under pipeline_version_reference for v2.
   * @type {string}
   * @memberof V2beta1Run
   */
  pipeline_version_id?: string;
  /**
   * Pipeline spec.
   * @type {object}
   * @memberof V2beta1Run
   */
  pipeline_spec?: object;
  /**
   *
   * @type {V2beta1PipelineVersionReference}
   * @memberof V2beta1Run
   */
  pipeline_version_reference?: V2beta1PipelineVersionReference;
  /**
   *
   * @type {V2beta1RuntimeConfig}
   * @memberof V2beta1Run
   */
  runtime_config?: V2beta1RuntimeConfig;
  /**
   * Optional input. Specifies which kubernetes service account is used.
   * @type {string}
   * @memberof V2beta1Run
   */
  service_account?: string;
  /**
   * Output. Creation time of the run.
   * @type {Date}
   * @memberof V2beta1Run
   */
  created_at?: Date;
  /**
   * Output. When this run is scheduled to start. This could be different from
   * created_at. For example, if a run is from a backfilling job that was supposed
   * to run 2 month ago, the created_at will be 2 month behind scheduled_at.
   * @type {Date}
   * @memberof V2beta1Run
   */
  scheduled_at?: Date;
  /**
   * Output. Completion of the run.
   * @type {Date}
   * @memberof V2beta1Run
   */
  finished_at?: Date;
  /**
   *
   * @type {V2beta1RuntimeState}
   * @memberof V2beta1Run
   */
  state?: V2beta1RuntimeState;
  /**
   *
   * @type {GoogleRpcStatus}
   * @memberof V2beta1Run
   */
  error?: GoogleRpcStatus;
  /**
   *
   * @type {V2beta1RunDetails}
   * @memberof V2beta1Run
   */
  run_details?: V2beta1RunDetails;
  /**
   * ID of the recurring run that triggered this run.
   * @type {string}
   * @memberof V2beta1Run
   */
  recurring_run_id?: string;
  /**
   * Output. A sequence of run statuses. This field keeps a record
   * of state transitions.
   * @type {Array<V2beta1RuntimeStatus>}
   * @memberof V2beta1Run
   */
  state_history?: Array<V2beta1RuntimeStatus>;
  /**
   * Optional input. Plugin-specific inputs provided by the user at run creation.
   * Each key is a plugin name (e.g., "mlflow") and the value is arbitrary JSON config.
   * @type {{ [key: string]: object; }}
   * @memberof V2beta1Run
   */
  plugins_input?: { [key: string]: object };
  /**
   * Output. Plugin-specific outputs populated by backend components.
   * Each key is a plugin name and the value contains the plugin's output entries and state.
   * @type {{ [key: string]: V2beta1PluginOutput; }}
   * @memberof V2beta1Run
   */
  plugins_output?: { [key: string]: V2beta1PluginOutput };
}

/**
 * Check if a given object implements the V2beta1Run interface.
 */
export function instanceOfV2beta1Run(value: object): value is V2beta1Run {
  return true;
}

export function V2beta1RunFromJSON(json: any): V2beta1Run {
  return V2beta1RunFromJSONTyped(json, false);
}

export function V2beta1RunFromJSONTyped(json: any, ignoreDiscriminator: boolean): V2beta1Run {
  if (json == null) {
    return json;
  }
  return {
    experiment_id: json['experiment_id'] == null ? undefined : json['experiment_id'],
    run_id: json['run_id'] == null ? undefined : json['run_id'],
    display_name: json['display_name'] == null ? undefined : json['display_name'],
    storage_state:
      json['storage_state'] == null
        ? undefined
        : V2beta1RunStorageStateFromJSON(json['storage_state']),
    description: json['description'] == null ? undefined : json['description'],
    pipeline_version_id:
      json['pipeline_version_id'] == null ? undefined : json['pipeline_version_id'],
    pipeline_spec: json['pipeline_spec'] == null ? undefined : json['pipeline_spec'],
    pipeline_version_reference:
      json['pipeline_version_reference'] == null
        ? undefined
        : V2beta1PipelineVersionReferenceFromJSON(json['pipeline_version_reference']),
    runtime_config:
      json['runtime_config'] == null
        ? undefined
        : V2beta1RuntimeConfigFromJSON(json['runtime_config']),
    service_account: json['service_account'] == null ? undefined : json['service_account'],
    created_at: json['created_at'] == null ? undefined : new Date(json['created_at']),
    scheduled_at: json['scheduled_at'] == null ? undefined : new Date(json['scheduled_at']),
    finished_at: json['finished_at'] == null ? undefined : new Date(json['finished_at']),
    state: json['state'] == null ? undefined : V2beta1RuntimeStateFromJSON(json['state']),
    error: json['error'] == null ? undefined : GoogleRpcStatusFromJSON(json['error']),
    run_details:
      json['run_details'] == null ? undefined : V2beta1RunDetailsFromJSON(json['run_details']),
    recurring_run_id: json['recurring_run_id'] == null ? undefined : json['recurring_run_id'],
    state_history:
      json['state_history'] == null
        ? undefined
        : (json['state_history'] as Array<any>).map(V2beta1RuntimeStatusFromJSON),
    plugins_input: json['plugins_input'] == null ? undefined : json['plugins_input'],
    plugins_output:
      json['plugins_output'] == null
        ? undefined
        : mapValues(json['plugins_output'], V2beta1PluginOutputFromJSON),
  };
}

export function V2beta1RunToJSON(json: any): V2beta1Run {
  return V2beta1RunToJSONTyped(json, false);
}

export function V2beta1RunToJSONTyped(
  value?: V2beta1Run | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    experiment_id: value['experiment_id'],
    run_id: value['run_id'],
    display_name: value['display_name'],
    storage_state: V2beta1RunStorageStateToJSON(value['storage_state']),
    description: value['description'],
    pipeline_version_id: value['pipeline_version_id'],
    pipeline_spec: value['pipeline_spec'],
    pipeline_version_reference: V2beta1PipelineVersionReferenceToJSON(
      value['pipeline_version_reference'],
    ),
    runtime_config: V2beta1RuntimeConfigToJSON(value['runtime_config']),
    service_account: value['service_account'],
    created_at:
      value['created_at'] == null ? value['created_at'] : value['created_at'].toISOString(),
    scheduled_at:
      value['scheduled_at'] == null ? value['scheduled_at'] : value['scheduled_at'].toISOString(),
    finished_at:
      value['finished_at'] == null ? value['finished_at'] : value['finished_at'].toISOString(),
    state: V2beta1RuntimeStateToJSON(value['state']),
    error: GoogleRpcStatusToJSON(value['error']),
    run_details: V2beta1RunDetailsToJSON(value['run_details']),
    recurring_run_id: value['recurring_run_id'],
    state_history:
      value['state_history'] == null
        ? undefined
        : (value['state_history'] as Array<any>).map(V2beta1RuntimeStatusToJSON),
    plugins_input: value['plugins_input'],
    plugins_output:
      value['plugins_output'] == null
        ? undefined
        : mapValues(value['plugins_output'], V2beta1PluginOutputToJSON),
  };
}
